import dayjs from 'dayjs';
import Model from '../models/model';
import consts from '../consts';
import util from '../util';
import { dataStore } from '../Store';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}

const { renderAttachmentButton } = util
const checkIsNotParametric = () => !isparametric();

const model = new Model({
	name: 'Cycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	title: "Ultrasonic Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: 'CycleName', width: 190 },
		{ field: 'CycleCount', header: 'CycleCount', type: 'int', width: 110 },
		{ field: 'CycleStatus', header: 'SterCycleStatus', width: 120 },
		{ field: 'CycleStart', header: 'CycleDateTime', type: 'dateTime', width: 200 },
		{ field: 'ErrorDescription', header: 'AlarmDescription', width: 260 },
		{ field: 'Label', header: 'Label', width: 200 },
		{ field: 'BIResult', header: 'BIResult', width: 200, type: 'int', hidden: true },
		{ field: 'InstrumentName', header: "Endoscope", width: 200, valueFormatter: util.removecommas },
		{ field: 'InstrumentSN', header: "EndoscopeId", width: 200, valueFormatter: util.removecommas },
		{ field: 'ModelNumber', header: "EndoscopeType", width: 200, valueFormatter: util.removecommas },
		{ field: 'OperatorName', header: "OperatorName", width: 200 },
		{ field: 'UnloadOperatorName', header: "UnloadOperator", width: 200, valueFormatter: util.removecommas },
		{ field: 'UnloadOperatorID', header: "UnloadOperatorID", width: 200, valueFormatter: util.removecommas },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row)), filterable: false, isNotExportField: true },
		{ field: 'CycleActionStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewDate', header: "ApprovedOn", width: 150, type: 'dateTime', isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewByUser', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});

export const UltrasonicTable = model;
export default model.createFormBase();
